// extracted by mini-css-extract-plugin
module.exports = {"avatat":"Profile_avatat__j7uKl"};